<template>
    <div class="about-legal-guardian-form3">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <div class="lock-message">
            <LockDefault :statusLock="0" />
            <div class="text">
                Caso queira que suas informações não sejam públicas, clique no icone do cadeado para ocultar.
            </div>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group label="Já empreendeu antes?" label-for="undertookBefore">
                <b-form-radio-group
                    name="undertookBefore"
                    stacked
                    v-model="form.undertookBefore.selected"
                    :options="form.undertookBefore.options"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['empreendeu_antes'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['empreendeu_antes'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasDrt')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Você é:" label-for="profession" class="required">
                <b-form-select
                    id="profession"
                    name="profession"
                    v-model="$v.form.profession.selected.$model"
                    :options="form.profession.options"
                    :state="validateState('profession')"
                    :disabled="getIsDisabled"
                    @change="onChangeProfession()"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['id_vocee'].value)"
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_vocee'].value"
                />

                <b-form-invalid-feedback :state="validateState('profession')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div v-if="form.profession.selected === 1">
                <b-form-group label="Possui DRT?" label-for="hasDrt" class="required">
                    <b-form-radio-group
                        id="hasDrt"
                        name="hasDrt"
                        stacked
                        v-model="$v.form.hasDrt.selected.$model"
                        :options="form.hasDrt.options"
                        :state="validateState('hasDrt')"
                        :disabled="getIsDisabled"
                        @change="onChangeHasDrt()"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['possui_drt'].value)
                        "
                    ></b-form-radio-group>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['possui_drt'].value"
                    />

                    <b-form-invalid-feedback :state="validateState('hasDrt')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Qual é o número do DRT?" label-for="drtNumber" v-if="form.hasDrt.selected">
                    <b-form-input
                        id="drtNumber"
                        name="drtNumber"
                        v-model="form.drtNumber"
                        placeholder="Digite o número"
                        :disabled="getIsDisabled"
                        v-if="
                            !isPlatform ||
                                (isPlatform && getAuthorizationData && getAuthorizationData['numero_drt'].value)
                        "
                    ></b-form-input>

                    <NoAuthorizationMsgPP
                        v-if="isPlatform && getAuthorizationData && !getAuthorizationData['numero_drt'].value"
                    />

                    <LockPP
                        :statusLock="form.drtNumberLock"
                        :lockMsg="'Privado'"
                        :unlockMsg="'Público'"
                        @click="form.drtNumberLock = Number(!form.drtNumberLock)"
                        v-if="showLock"
                    />
                </b-form-group>
            </div>

            <h6>Nos conhecendo melhor</h6>

            <b-form-group label="O que te motivou a empreender?" label-for="reasonEngage">
                <b-form-textarea
                    id="reasonEngage"
                    name="reasonEngage"
                    v-model="form.reasonEngage"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['motivou_empreender'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['motivou_empreender'].value"
                />

                <LockPP
                    :statusLock="form.reasonEngageLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.reasonEngageLock = Number(!form.reasonEngageLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group label="Qual é o seu sonho com seu negócio?" label-for="dream">
                <b-form-textarea
                    id="dream"
                    name="dream"
                    v-model="form.dream"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['sonho_negocio'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['sonho_negocio'].value"
                />

                <LockPP
                    :statusLock="form.dreamLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.dreamLock = Number(!form.dreamLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group
                label="Qual tipo de conteúdo você cria? Conte um pouco."
                label-for="aboutContent"
                v-if="form.profession.selected === 2"
            >
                <b-form-textarea
                    id="aboutContent"
                    name="aboutContent"
                    v-model="form.aboutContent"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['tipo_conteudo'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['tipo_conteudo'].value"
                />

                <LockPP
                    :statusLock="form.aboutContentLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.aboutContentLock = Number(!form.aboutContentLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group
                label="Qual tipo de evento você produz? Conte um pouco."
                label-for="aboutEvent"
                v-if="form.profession.selected === 3"
            >
                <b-form-textarea
                    id="aboutEvent"
                    name="aboutEvent"
                    v-model="form.aboutEvent"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['tipo_evento'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['tipo_evento'].value"
                />

                <LockPP
                    :statusLock="form.aboutEventLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.aboutEventLock = Number(!form.aboutEventLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutLegalGuardianForm2' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutLegalGuardianForm2')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="changeRegisterForm('AboutInitiativeForm1')"
                        v-if="abbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :no-close-on-backdrop="true"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })"
                    >Continuar na plataforma</b-button
                >
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutLegalGuardianApi } from '../../api/register-about-legal-guardian'
import LockDefault from '@/ui/lock-default/LockDefault'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()

const aboutLegalGuardianApi = new AboutLegalGuardianApi()

export default {
    components: { LockPP, SuccessMsgModal, DangerModalPP, LockDefault, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 16.62,
            isUpdate: false,
            legalGuardianData: null,
            isDisabled: null,
            message: null,
            authorizationData: null,
            form: {
                profession: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                hasDrt: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                undertookBefore: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                drtNumber: null,
                drtNumberLock: 1,
                reasonEngage: null,
                reasonEngageLock: 1,
                dream: null,
                dreamLock: 1,
                aboutContent: null,
                aboutContentLock: 1,
                aboutEvent: null,
                aboutEventLock: 1
            }
        }
    },
    validations: {
        form: {
            profession: {
                selected: { required }
            },
            hasDrt: {
                selected: {
                    required() {
                        return !(this.form.hasDrt.selected === null && this.form.profession.selected === 1)
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.profession.selected = data.id_vocee
            this.form.hasDrt.selected = data.possui_drt
            this.form.undertookBefore.selected = data.empreendeu_antes
            this.form.drtNumber = data.numero_drt
            this.form.drtNumberLock = data.view_numero_drt === null ? 1 : data.view_numero_drt
            this.form.reasonEngage = data.motivou_empreender
            this.form.reasonEngageLock = data.view_motivou_empreender === null ? 1 : data.view_motivou_empreender
            this.form.dream = data.sonho_negocio
            this.form.dreamLock = data.view_sonho_negocio === null ? 1 : data.view_sonho_negocio
            this.form.aboutContent = data.tipo_conteudo
            this.form.aboutContentLock = data.view_tipo_conteudo === null ? 1 : data.view_tipo_conteudo
            this.form.aboutEvent = data.tipo_evento
            this.form.aboutEventLock = data.view_tipo_evento === null ? 1 : data.view_tipo_evento

            this.setIsLoading(true)

            axios
                .all([aboutLegalGuardianApi.getYouAre()])
                .then(response => {
                    this.form.profession.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.voce }))
                    )

                    this.fetchAuthorization()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutLegalGuardianApi.getLegalGuardian(), aboutLegalGuardianApi.getYouAre()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.legalGuardianData = data
                        this.form.profession.selected = data.id_vocee
                        this.form.hasDrt.selected = data.possui_drt
                        this.form.undertookBefore.selected = data.empreendeu_antes
                        this.form.drtNumber = data.numero_drt
                        this.form.drtNumberLock = data.view_numero_drt === null ? 1 : data.view_numero_drt
                        this.form.reasonEngage = data.motivou_empreender
                        this.form.reasonEngageLock =
                            data.view_motivou_empreender === null ? 1 : data.view_motivou_empreender
                        this.form.dream = data.sonho_negocio
                        this.form.dreamLock = data.view_sonho_negocio === null ? 1 : data.view_sonho_negocio
                        this.form.aboutContent = data.tipo_conteudo
                        this.form.aboutContentLock = data.view_tipo_conteudo === null ? 1 : data.view_tipo_conteudo
                        this.form.aboutEvent = data.tipo_evento
                        this.form.aboutEventLock = data.view_tipo_evento === null ? 1 : data.view_tipo_evento

                        this.setProgress(data.percentual)
                    }

                    this.form.profession.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.voce }))
                    )
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.legalGuardianData,
                id_vocee: this.form.profession.selected,
                possui_drt: this.form.hasDrt.selected,
                empreendeu_antes: this.form.undertookBefore.selected,
                numero_drt: this.form.drtNumber,
                view_numero_drt: this.form.drtNumberLock,
                motivou_empreender: this.form.reasonEngage,
                view_motivou_empreender: this.form.reasonEngageLock,
                sonho_negocio: this.form.dream,
                view_sonho_negocio: this.form.dreamLock,
                tipo_conteudo: this.form.aboutContent,
                view_tipo_conteudo: this.form.aboutContentLock,
                tipo_evento: this.form.aboutEvent,
                view_tipo_evento: this.form.aboutEventLock,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutLegalGuardianApi.updateLegalGuardian(data)
                : aboutLegalGuardianApi.finishLegalGuardian(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.showModal('warning-modal-ref')
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onChangeProfession() {
            this.form.aboutEvent = null
            this.form.aboutContent = null
            this.form.hasDrt.selected = null
            this.form.drtNumber = null
        },
        onChangeHasDrt() {
            if (!this.form.hasDrt.selected) {
                this.form.drtNumber = null
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'AboutInitiativeForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getLegalGuardian(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    mounted() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutLegalGuardianForm3-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-legal-guardian/AboutLegalGuardianForm3.vue